var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fade-transition',{attrs:{"duration":600}},[_c('b-container',[_c('top'),_c('router-view'),_c('div',{staticClass:"line-right"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }